<h2 mat-dialog-title>Override Status</h2>
<mat-dialog-content>
  <mat-action-list>
    @for (status of statuses; track status) {
      <button
        mat-list-item
        (click)="select(status.value)"
        [disabled]="isSelected(status.value)"
        class="status-option"
      >
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <svg width="15" height="10">
            <circle
              [class]="getStatusClass(status.label)"
              class="status-dot"
              cx="5"
              cy="5"
              r="4"
              stroke-width="0"
            />
          </svg>
          <span>{{ status.label }}</span>
          @if (isSelected(status.value)) {
            <mat-icon>check</mat-icon>
          }
        </div>
      </button>
    }
  </mat-action-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="dialogRef.close()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">Update</button>
</mat-dialog-actions>
